<template>
  <div>
    <RelatorioPaisagem>
      <b-table
        striped
        small
        style="text-align: center"
        id="table_export_id"
        :head-variant="'light'"
        :items="params.items"
        :fields="params.fields"
        foot-clone
      >
        <template #foot()>
          <span> {{ '' }} </span>
        </template>

        <template #foot(contract_number)>
          <span>Total: </span>
        </template>

        <template #foot(installment_value)>
          <span>{{ formatarValor(params.installment_total) }} </span>
        </template>
      </b-table>
    </RelatorioPaisagem>
  </div>
</template>

<script>
  import { formatarValor } from '@/libs/utils'
  import RelatorioPaisagem from '@/views/pages/relatorio/relatorioPaisagem.vue'

  export default {
    components: {
      RelatorioPaisagem,
    },
    props: {
      params: {},
    },
    data() {
      return {
        formatarValor,
      }
    },
  }
</script>

<style></style>
